// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__184up","signatureButtonsRight":"ModalSign_signatureButtonsRight__1kMWg"};